module.exports = __webpack_public_path__ + "img/8.4ce9a0d9.webp";